// banner
const homeBananaMove = require('common/ter/images/home_banana_move.png')
// 最新产品
const moveProduct01 = require('common/ter/images/move_product_01.png')
const moveProduct02 = require('common/ter/images/move_product_02.png')
const product_inhim = require('common/ter/images/product_inhim.png')
const moveProduct03 = require('common/ter/images/move_product_03.png')
const product_qmz = require('common/ter/images/product_qmz.png')
// 中间
const homeBanner01 = require('common/ter/images/home_culture_01.png')
const homeBanner02 = require('common/ter/images/home_culture_02.png')
const homeBanner03 = require('common/ter/images/home_culture_03.png')
// 最新产品
const church01 = require('common/ter/images/church_01.png')
const church02 = require('common/ter/images/church_02.png')
const church03 = require('common/ter/images/church_03.png')

const data = {
	bannerData: {
		imgRul: homeBananaMove,
		link: '/ter/aboutUs',
		name: '因他科技',
		tip: '专注',
		intro: '主内云生态',
		content: '深耕主内互联网需求，力争前沿'
	},
	newProduce: {
		moreLink: '/ter/produce',
		contentList: [{
				imgUrl: product_qmz,
				imgLink: 'https://qmz.app/',
				targetBlank: true
			},{
				imgUrl: product_inhim,
				imgLink: 'http://ly.bible.ac.cn/elearn_v2/assets/android/inhim.html',
				targetBlank: true
			}, {
				imgUrl: moveProduct01,
				imgLink: 'https://bible.com.cn/downapp.html',
				targetBlank: true
			},
			{
				imgUrl: moveProduct02,
				imgLink: 'https://android.myapp.com/myapp/detail.htm?apkName=com.zhunei.ed365&ADTAG=mobile',
				targetBlank: true
			}
		]
	},
	homeIntro: [{
			imgUrl: homeBanner01,
			content: [{
					txt: '根植',
					lig: '主内文化'
				},
				{
					txt: '沿袭倍增生命',
					lig: null
				}
			]
		},
		{
			imgUrl: homeBanner02,
			content: [{
					txt: '普及',
					lig: '无纸化办公'
				},
				{
					txt: '团队需求定制',
					lig: null
				}
			]
		},
		{
			imgUrl: homeBanner03,
			content: [{
					txt: '承接',
					lig: '互联网新时代'
				},
				{
					txt: '我们争做试金石',
					lig: null
				}
			]
		}
	],
	customerInfo: [{
			imgUrl: church01,
			name: '深圳堂',
			local: '深圳市'
		},
		{
			imgUrl: church02,
			name: '国际礼拜堂',
			local: '宁波市'
		},
		{
			imgUrl: church03,
			name: '侨城堂',
			local: '深圳'
		}
	]
}
export default data



// WEBPACK FOOTER //
// ./src/common/ter/js/home.js